import { render, staticRenderFns } from "./SidsTable.vue?vue&type=template&id=35eb4b04&scoped=true"
import script from "./SidsTable.vue?vue&type=script&lang=js"
export * from "./SidsTable.vue?vue&type=script&lang=js"
import style0 from "./SidsTable.vue?vue&type=style&index=0&id=35eb4b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb4b04",
  null
  
)

export default component.exports